// extracted by mini-css-extract-plugin
export default {"hdpFeebk":"index_hdpFeebk_a-KFB","login":"index_login_Ktsrq"};